import { EventType } from '@monofront/types';
import { LogLevel, faro } from '@grafana/faro-web-sdk';

/**
 * Names of events that we want to send only once per page
 */
const UNIQUE_EVENTS = [
  'LFViewItem',
  'LFStartCheckout',
  'LFAddShippingInfo',
  'LFPurchase',
  'LFStartFreeTrial',
  'LFPageView',
  'LFRedeemReferral',
  'LFSignUp',
  'LFMinimumOrderAmountNotReached',
  'LFOpenMembershipModal',
  'LFResetPassword',
  'LFRequestResetPassword',
  'LFStartPasswordTypeSignUp',
  'LFProductClickedOrder',
  'LFManualAddressFormOpened',
  'LFManualAddressFormCompleted',
];

const state = {
  uniqueEventsSent: [] as Array<string>,
};

export const trackEvent = ({ type, data }: EventType) => {
  if (typeof window !== 'undefined') {
    if (UNIQUE_EVENTS.includes(type) && state.uniqueEventsSent.includes(type)) {
      if ('google_tag_manager' in window) {
        const error = new Error('GTM event sent more than once!');

        // warn only if we can clear the dataLayer
        const context = {
          gaEventType: type,
          data: JSON.stringify(data),
          previous: JSON.stringify(
            window.dataLayer
              .slice()
              .reverse()
              .find((e) => e.event === type),
          ),
        };

        // faro.config (not faro.api, which is a pre-init noop stub) marks
        // the SDK as initialized
        if (faro.config) {
          faro.api.pushLog([error.message], {
            level: LogLevel.WARN,
            context,
          });
        } else {
          // eslint-disable-next-line no-console
          console.warn(error.message, context);
        }
      }
    } else {
      state.uniqueEventsSent.push(type);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: type,
      ...data,
    });
  }
};

export const cleanEventSentState = () => {
  state.uniqueEventsSent = [];
};
